<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{ text }}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <loading :active.sync="load" :is-full-page="true" color="green"></loading>
    <v-divider></v-divider>
    <v-card flat>
      <v-container grid-list-xs>
        <v-layout wrap>
          <v-flex xs12 sm5 md5 mb-1>
            <v-card class="rounded-card" heigh="360px">
              <v-card-text>
                
                 <v-layout justify-center align-center>
             <h2 class="dark-grey--text">SLA Summary</h2>
              <v-btn
                small
                v-if="!editingSla"
                round
                class="primary"
                @click="editingSla = !editingSla"
              >
                <v-icon small color="white">edit</v-icon>Edit
              </v-btn>
              <v-btn
                small
                round
                color="primary"
                v-if="editingSla"
                @click="editSlaInfo()"
                >Done
              </v-btn>
            </v-layout>
                <!-- <v-btn @click="findSimilarContacts('Mark')">Similar Xero Contacts</v-btn> -->
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout
                        justify-center
                        
                      >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Customer:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3 v-if="serviceDetail.customerOrganisation" class="grey--text font-weight-light">
                            {{ serviceDetail.customerOrganisation.name }}
                          </h3>
                        </v-flex>
                         <v-flex xs6 v-else>
                          <v-autocomplete class="input-flex-min-space"
                         ref="customerOrganisationId" v-on:blur="$refs['customerOrganisationId'].blur()"
                           v-model="serviceDetail.customerOrganisationId" :items="customers" label="Customer" item-text="name" item-value="id"></v-autocomplete>

                        </v-flex>
                      </v-layout>

                      <v-layout
                        justify-center
                        
                      >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Network:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3 v-if="serviceDetail.locationNetwork" class="grey--text font-weight-light">
                            {{ serviceDetail.locationNetwork.name }}
                          </h3>
                        </v-flex>
                         <v-flex xs6 v-else>
                           <v-autocomplete class="input-flex-min-space" 
                           ref="locationNetworkId" v-on:blur="$refs['locationNetworkId'].blur()"
                           v-model="serviceDetail.locationNetworkId" :items="locationNetworks" label="Network" item-text="name" item-value="id"></v-autocomplete>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Type:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3 v-if="serviceDetail.type" class="grey--text font-weight-light">
                            {{ serviceDetail.type }}
                          </h3>
                        </v-flex>
                        <v-flex xs6 v-else>
                         <v-select class="input-flex-min-space"
                         :items="slaTypes" v-model="serviceDetail.type" label="Type"></v-select>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Name:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3 v-if="serviceDetail.name" class="grey--text font-weight-light">
                            {{ serviceDetail.name }}
                          </h3>
                        </v-flex>
                        <v-flex xs6 v-else>
                          <v-text-field class="input-flex-min-space"
                          v-model="serviceDetail.name" label="Name"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Start Date:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3  v-if="serviceDetail.startDate" class="grey--text font-weight-light">
                            <v-chip
                              color="light-green"
                              small
                              class="white--text"
                            >
                              <b>{{ formatDate(serviceDetail.startDate) }}</b>
                            </v-chip>
                          </h3>
                        </v-flex>
                        <v-flex xs6 v-else>
                          <VueCtkDateTimePicker
                label="Start Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="serviceDetail.startDate"
              />
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            End Date:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3 v-if="serviceDetail.endDate" class="grey--text font-weight-light">
                            <v-chip color="red" small class="white--text">
                              <b>{{ formatDate(serviceDetail.endDate) }}</b>
                            </v-chip>
                          </h3>
                        </v-flex>
                        <v-flex xs6 v-else>
                          <VueCtkDateTimePicker
                label="End Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="serviceDetail.endDate"
              />
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center >
                        <v-flex xs6>
                          <h2 class="mt-2 subheading grey--text font-weight-bold">
                            Monthly Hours:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3 v-if="serviceDetail.hours" class="mt-2 grey--text font-weight-light">
                            {{ serviceDetail.hours }}
                          </h3>
                        </v-flex>
                        <v-flex xs6 v-else>
                          <v-text-field 
                          type="number" v-model="serviceDetail.hours" label="Monthly Hours"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Hourly Rate:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3 v-if="serviceDetail.hourlyRate" class="grey--text font-weight-light">
                            {{ serviceDetail.hourlyRate | currency }}
                          </h3>
                        </v-flex>
                        <v-flex xs6 v-else>
                          <v-text-field class="input-flex-min-space"
                           prefix="R" type="number" v-model="serviceDetail.hourlyRate" label="Hourly Rate"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Overtime Hourly Rate:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3  v-if="serviceDetail.afterHourRate" class="grey--text font-weight-light">
                            {{ serviceDetail.afterHourRate | currency }}
                          </h3>
                        </v-flex>
                        <v-flex xs6 v-else>
                           <v-text-field class="input-flex-min-space"
                           prefix="R" type="number" v-model="serviceDetail.afterHourRate" label="Overtime Hourly Rate"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                           Sunday & Public Holiday Hourly Rate:
                          </h2>
                        </v-flex>
                        <v-flex xs6 v-if="!editingSla">
                          <h3 v-if="serviceDetail.sundayAndPublicHolidayRate" class="grey--text font-weight-light">
                            {{ serviceDetail.sundayAndPublicHolidayRate | currency }}
                          </h3>
                        </v-flex>
                        <v-flex xs6 v-else>
                            <v-text-field class="input-flex-min-space"
                            prefix="R" type="number" v-model="serviceDetail.sundayAndPublicHolidayRate" label="Sunday & Public Holiday Hourly Rate"></v-text-field>
                        </v-flex>
                      </v-layout>
                     
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md5 mb-1 mx-1>
            <v-card class="rounded-card" heigh="360px">
              <v-card-text>
                <v-layout justify-center>
                  <v-flex xs6>
                    <v-select
                      xs6
                      @change="fetchHoursUsed()"
                      v-model="selectedMonth"
                      label="Select a month"
                      :items="availableMonths.map((x) => formatMonth(x))"
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center align-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Issues Logged:
                          </h2>
                        </v-flex>
                        <v-flex xs6>
                          <v-chip
                            class="white--text"
                            color="blue"
                            :key="dateKey"
                            >{{
                              tickets.filter(
                                (x) =>
                                  new Date(x.createdAt) <=
                                    new Date(
                                      selectedDate.getFullYear(),
                                      selectedDate.getMonth() + 1,
                                      0
                                    ) &&
                                  new Date(x.createdAt) >=
                                    new Date(
                                      selectedDate.getFullYear(),
                                      selectedDate.getMonth(),
                                      1
                                    )
                              ).length
                            }}</v-chip
                          >
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center align-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Issues Resolved:
                          </h2>
                        </v-flex>
                        <v-flex xs6>
                          <v-chip
                            class="white--text"
                            color="light-green"
                            :key="dateKey"
                            >{{
                              tickets.filter(
                                (x) =>
                                  x.isComplete &&
                                  new Date(x.createdAt) <=
                                    new Date(
                                      selectedDate.getFullYear(),
                                      selectedDate.getMonth() + 1,
                                      0
                                    ) &&
                                  new Date(x.createdAt) >=
                                    new Date(
                                      selectedDate.getFullYear(),
                                      selectedDate.getMonth(),
                                      1
                                    )
                              ).length
                            }}</v-chip
                          >
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Hours Used:
                          </h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            :key="dateKey"
                          >
                            {{ hoursUsed }}
                          </h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Hours Remaining:
                          </h2>
                        </v-flex>
                        <v-flex xs6 :key="dateKey">
                          <h3
                            class="grey--text font-weight-light"
                            v-if="serviceDetail.hours - hoursUsed >= 0"
                          >
                            {{ (serviceDetail.hours - hoursUsed).toFixed(2) }}
                          </h3>
                          <h3 class="grey--text font-weight-light" v-else>0</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        justify-center
                        v-if="serviceDetail.hours - hoursUsed < 0"
                      >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Additional Hours:
                          </h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ (hoursUsed - serviceDetail.hours).toFixed(2) }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        justify-center
                        v-if="serviceDetail.hours - hoursUsed < 0"
                      >
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">
                            Additional Charge:
                          </h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{
                              ((hoursUsed - serviceDetail.hours) *
                                serviceDetail.hourlyRate)
                                | currency
                            }}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 mb-1 mx-1>
            <v-card class="rounded-card" heigh="360px">
              <v-card-text>
                <v-layout align-center justify-center>
                  <h2 class="dark-grey--text">Tickets</h2>
                  <v-icon color="primary" @click="addTicket()"
                    >add_circle_outline</v-icon
                  >
                </v-layout>

                <!-- <v-btn @click="findSimilarContacts('Mark')">Similar Xero Contacts</v-btn> -->
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-data-table
                        :loading="loading"
                        :headers="headers"
                        :items="tickets"
                      >
                        <template v-slot:items="props">
                          <td @click="editTicket(props.item.id)">
                            <h3 class="grey--text">
                              <v-chip
                                small
                                :class="`${props.item.currentStatus
                                  .replace(/\s/g, '')
                                  .toLowerCase()} white--text`"
                                >{{ props.item.currentStatus }}</v-chip
                              >
                            </h3>
                          </td>
                          <td @click="editTicket(props.item.id)">
                            <h3 class="grey--text font-weight-light">
                              {{ props.item.id }}
                            </h3>
                          </td>
                          <td @click="editTicket(props.item.id)">
                            <h3 class="grey--text font-weight-light">
                              {{
                                props.item.ticketCategoryItem.ticketCategory
                                  .name
                              }}
                            </h3>
                          </td>
                          <td @click="editTicket(props.item.id)">
                            <h3 class="grey--text font-weight-light">
                              {{ props.item.ticketCategoryItem.name }}
                            </h3>
                          </td>
                          <td @click="editTicket(props.item.id)">
                            <h3
                              v-if="props.item.description"
                              class="longText grey--text font-weight-light"
                            >
                              {{ props.item.description }}
                            </h3>
                          </td>
                          <td @click="editTicket(props.item.id)">
                            <h3 class="grey--text">
                              <v-chip
                                small
                                :class="`${props.item.importance
                                  .replace(/\s/g, '')
                                  .toLowerCase()} white--text`"
                                >{{ props.item.importance }}</v-chip
                              >
                            </h3>
                          </td>
                          <td @click="editTicket(props.item.id)">
                            <h3
                              class="grey--text font-weight-light"
                              v-if="props.item.createdBy"
                            >
                              {{ props.item.createdBy.name }}
                              {{ props.item.createdBy.surname }}
                            </h3>
                          </td>
                          <td @click="editTicket(props.item.id)">
                            <h3
                              v-if="props.item.assignedTo"
                              class="grey--text font-weight-light"
                            >
                              {{ props.item.assignedTo.name }}
                              {{ props.item.assignedTo.surname }}
                            </h3>
                            <h3 v-else class="grey--text font-weight-light">
                              Unassigned
                            </h3>
                          </td>
                          <td @click="editTicket(props.item.id)">
                            <h3
                              v-if="props.item.resolvedBy"
                              class="grey--text font-weight-light"
                            >
                              {{ props.item.resolvedBy.name }}
                              {{ props.item.resolvedBy.surname }}
                            </h3>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-dialog v-model="addTicketModal" persistent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">
            ADD TICKET: {{ ticketOptions.dueDate }}
          </h3>
          <v-spacer></v-spacer>

          <v-btn
            v-if="
              ticketOptions.ticketCategoryId &&
              ticketOptions.ticketCategoryItemId &&
              ticketOptions.currentStatus &&
              ticketOptions.importance &&
              ticketOptions.dueDate
            "
            flat
            color="white"
            class="white--text"
            @click="createNewTicket()"
            >Save</v-btn
          >
          <v-btn v-else disabled flat>Save</v-btn>
          <v-btn
            flat
            color="white"
            class="white--text"
            @click="(addTicketModal = false), (ticketOptions = {})"
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex>
              <v-checkbox
                label="Add from template"
                v-model="addTemplate"
              ></v-checkbox>
            </v-flex>
            <v-flex v-if="addTemplate">
              <v-autocomplete
                v-model="ticketOptions.ticketTemplateId"
                :items="ticketTemplates"
                clearable
                item-text="name"
                item-value="id"
                label="Ticket Template"
                @click:clear="clearTemplate()"
                v-on:change="populateTemplate()"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-checkbox
                label="Full Day Event"
                v-model="dateTimeSelect"
              ></v-checkbox>
            </v-flex>
            <v-flex>
              <VueCtkDateTimePicker
              :key="key"
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketOptions.dueDate"
              />
            </v-flex>
            <v-flex>
              <VueCtkDateTimePicker
              :key="key"
                v-if="!dateTimeSelect"
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketOptions.dueTime"
              />
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex xs3 mx-2>
              <v-autocomplete
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketOptions.ticketCategoryId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-autocomplete
                v-if="ticketOptions.ticketCategoryId"
                xs6
                :items="filteredCategoryItems"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketOptions.ticketCategoryItemId"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                xs6
                disabled
                :items="ticketCategories"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-select
                :items="statuses"
                label="Status"
                v-model="ticketOptions.currentStatus"
              ></v-select>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-select
                :items="importanceOptions"
                label="Importance"
                v-model="ticketOptions.importance"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 mx-2>
              <v-autocomplete
                clearable
                :items="userRoles"
                label="User Role"
                item-text="name"
                item-value="id"
                v-model="ticketOptions.userRoleId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-autocomplete
                v-if="ticketOptions.userRoleId"
                v-model="ticketOptions.assignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="blue-grey"
                    class="white--text"
                    v-on="on"
                  >
                    <v-icon left>person</v-icon>
                    <span>{{ item.name }} {{ item.surname }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item !== 'undefined'"
                    >{{ item.name.charAt(0)
                    }}{{ item.surname.charAt(0) }}</v-avatar
                  >
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3"
                      >{{ item.name }} {{ item.surname }}</v-list-item-title
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-else
                disabled
                v-model="filterAssignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assigned User"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-select
                :items="locationTypeList"
                label="Type of Associated Location"
                v-model="locationType"
              ></v-select>
            </v-flex>
            <v-flex xs3 mx-2 v-if="locationType === 'Switching Centre'">
              <v-autocomplete
                clearable
                :items="switchingCentres"
                label="Select a Switching Centre"
                item-value="id"
                item-text="name"
                v-model="ticketOptions.switchingCentreId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2 v-if="locationType === 'Location Node'">
              <v-autocomplete
                clearable
                :items="locationNodes"
                label="Select a Node"
                item-value="id"
                item-text="name"
                v-model="ticketOptions.locationNodeId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2 v-if="locationType === 'Location Network'">
              <v-autocomplete
                clearable
                :items="locationNetworks"
                label="Select a Network"
                item-value="id"
                item-text="name"
                v-model="ticketOptions.locationNetworkId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs2 mx-2 v-if="locationType === 'End Location'">
              <v-btn
                v-if="!ticketOptions.locationId"
                round
                color="primary"
                class="white--text"
                @click="addLocationModal = true"
                >Add Location</v-btn
              >
              <v-btn
                v-else
                round
                color="primary"
                class="white--text"
                @click="addLocationModal = true"
                >Edit Location</v-btn
              >
            </v-flex>
            <v-flex
              xs4
              mx-1
              v-if="locationType === 'End Location' && ticketOptions.locationId"
            >
              <h3 class="grey--text font-weight-light wrap">
                {{ ticketOptions.location.locationDescription }}
              </h3>
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-textarea
              label="Description"
              outline
              auto-grow
              v-model="ticketOptions.description"
            ></v-textarea>
          </v-layout>
          <v-layout justify-center v-if="ticketAssignedLog.length > 0">
            <v-flex xs12>
              <h3 class="grey--text">Assignment Log:</h3>
            </v-flex>
            <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned">
              <v-layout justify-left align-center class="text-xs-left">
                <v-flex xs4>
                  <h3 class="grey--text">
                    {{ assigned.assignedBy.name }}
                    {{ assigned.assignedBy.surname }}
                  </h3>
                </v-flex>
                <v-flex xs4>
                  <h3 class="grey--text">
                    {{ assigned.assignedTo.name }}
                    {{ assigned.assignedTo.surname }}
                  </h3>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs6 mx-1>
              <v-layout justify-center align-center mt-4 mb-2>
                <v-flex xs2>
                  <h3 class="grey--text">Comments:</h3>
                </v-flex>
                <v-flex xs1>
                  <v-icon color="primary" @click="addCommentBox = true"
                    >add_circle_outline</v-icon
                  >
                </v-flex>
              </v-layout>
              <v-flex
                xs12
                v-if="ticketCommentLog.length === 0 && !addCommentBox"
              >
                <h3 class="grey--text font-weight-light">No Comments</h3>
              </v-flex>
              <v-flex xs12 v-if="addCommentBox">
                <v-textarea
                  label="Comment"
                  outline
                  auto-grow
                  v-model="comment"
                ></v-textarea>
                <v-btn
                  round
                  color="primary"
                  class="white--text"
                  @click="addComment(comment)"
                  >Comment</v-btn
                >
              </v-flex>
              <!-- <v-card flat style="overflow-y: auto;" >
                      <v-layout wrap>
          <v-flex v-for="comment in ticketCommentLog" :key="comment.createdAt">
            <v-layout justify-left align-center>
                <span class="mx-2 grey--text font-weight-light">{{formatDateTime(comment.createdAt)}}</span>
                <span
                  class="mx-2 grey--text font-weight-bold"
                >{{comment.commentedBy.name}} {{comment.commentedBy.surname}}</span>   
                <span class="mx-2 grey--text font-weight-light">{{comment.comment}}</span>            
            </v-layout>
          </v-flex>
          </v-layout>
           </v-card> -->
            </v-flex>

            <v-flex xs6 mx-1>
              <v-layout justify-center align-center mt-4 mb-2>
                <v-flex xs3>
                  <h3 class="grey--text">Job Hours:</h3>
                </v-flex>
                <v-flex xs1>
                  <v-icon color="primary" @click="addHoursBox = true"
                    >add_circle_outline</v-icon
                  >
                </v-flex>
              </v-layout>
              <v-flex xs12 v-if="ticketHoursLog.length === 0 && !addHoursBox">
                <h3 class="grey--text font-weight-light">No Job Hours</h3>
              </v-flex>
              <v-flex xs12 v-if="addHoursBox">
                <v-layout>
                  <VueCtkDateTimePicker
                    label="Start Date"
                    autoClose
                    format="YYYY-MM-DD"
                    formatted="ll"
                    only-date
                    v-model="ticketHours.startDate"
                  />

                  <VueCtkDateTimePicker
                    format="HH:mm"
                    formatted="HH:mm"
                    minuteInterval="5"
                    label="Start Time"
                    only-time
                    v-model="ticketHours.startTime"
                  />
                </v-layout>
                <v-layout>
                  <VueCtkDateTimePicker
                    label="Stopped Date"
                    autoClose
                    format="YYYY-MM-DD"
                    formatted="ll"
                    only-date
                    v-model="ticketHours.stoppedDate"
                  />

                  <VueCtkDateTimePicker
                    format="HH:mm"
                    formatted="HH:mm"
                    minuteInterval="5"
                    label="Stopped Time"
                    only-time
                    v-model="ticketHours.stoppedTime"
                  />
                </v-layout>
                <v-autocomplete
                  v-model="ticketHours.contactId"
                  :items="filteredUsers"
                  :filter="filterObject"
                  chips
                  clearable
                  item-text="name"
                  item-value="id"
                  label="Contact"
                >
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <v-chip
                      v-bind="attr"
                      :input-value="selected"
                      color="blue-grey"
                      class="white--text"
                      v-on="on"
                    >
                      <v-icon left>person</v-icon>
                      <span>{{ item.name }} {{ item.surname }}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-avatar
                      size="35px"
                      color="primary"
                      class="title font-weight-light white--text"
                      v-if="item !== 'undefined'"
                    >
                      {{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}
                    </v-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="grey--text ml-3"
                        >{{ item.name }} {{ item.surname }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
                <v-btn
                  round
                  color="primary"
                  class="white--text"
                  @click="addHours(ticketHours)"
                  >Add Job Hours</v-btn
                >
              </v-flex>
              <!-- <v-flex xs12 v-for="ticketHour in ticketHoursLog" :key="ticketHour.createdAt">
            <v-layout justify-left align-center class="text-xs-left">
                <span class="mx-2 grey--text font-weight-light">{{formatDateTime(ticketHour.startDate)}}</span>
                <span
                  class="mx-2 grey--text font-weight-bold"
                >{{ticketHour.contactName}} {{ticketHour.contactSurname}}</span>
                    <span style="text-align:left " class="mt-1 grey--text font-weight-light "> started working</span>
               <span v-if="ticketHour.stoppedDate" style="text-align:left " class="mt-1 grey--text font-weight-light ml-1">until {{formatDateTime(ticketHour.stoppedDate)}}</span>

            </v-layout>
          </v-flex> -->
            </v-flex>
          </v-layout>
          <v-layout>
            <v-card flat style="overflow-y: auto; max-height: 1000px">
              <v-container style="text-align: left">
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="item in logArray"
                    :key="item.id"
                  >
                    <h3 class="grey--text font-weight-light">
                      {{ formatDateTime(item.createdAt) }}
                    </h3>

                    <v-layout v-if="item.commentLogType == true">
                      <span>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-avatar
                              v-on="on"
                              size="30px"
                              color="primary"
                              style="width: 30px"
                              class="mx-1 font-weight-light white--text"
                              v-if="item !== 'undefined'"
                              >{{ item.commentedByName.charAt(0)
                              }}{{
                                item.commentedBySurname.charAt(0)
                              }}</v-avatar
                            >
                          </template>
                          <span class="font-weight-light"
                            >{{ item.commentedByName }}
                            {{ item.commentedBySurname }}</span
                          >
                        </v-tooltip></span
                      >
                      <span
                        style="text-align: left"
                        class="mt-1 grey--text font-weight-light"
                        >{{ item.comment }}</span
                      >
                    </v-layout>
                    <v-layout v-else-if="item.commentLogType == false">
                      <span>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-avatar
                              v-on="on"
                              size="30px"
                              color="primary"
                              style="width: 30px"
                              class="mx-1 font-weight-light white--text"
                              v-if="item !== 'undefined'"
                              >{{ item.contactName.charAt(0)
                              }}{{ item.contactSurname.charAt(0) }}</v-avatar
                            >
                          </template>
                          <span class="font-weight-light"
                            >{{ item.contactName }}
                            {{ item.contactSurname }}</span
                          >
                        </v-tooltip></span
                      >
                      <span
                        style="text-align: left"
                        class="mt-1 grey--text font-weight-light"
                        >started working
                      </span>
                      <span
                        v-if="item.stoppedDate"
                        style="text-align: left"
                        class="mt-1 grey--text font-weight-light ml-1"
                      >
                        until {{ formatDateTime(item.stoppedDate) }}</span
                      >
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addLocationModal" persistent max-width="1200px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">ADD LOCATION</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="addLocationModal = false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-autocomplete
            :items="locationNetworks"
            label="Filter By Network"
            clearable
            item-value="id"
            item-text="name"
            v-model="locationFilter"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-text-field
            label="Search"
            v-model="locationSearch"
            clearable
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :items="filteredLocations"
            :headers="locationHeaders"
            :search="locationSearch"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                <v-icon
                  @click="
                    (ticketOptions.location = props.item),
                      (ticketOptions.locationId = props.item.id),
                      (addLocationModal = false)
                  "
                  color="primary"
                  >add_circle_outline</v-icon
                >
              </td>
              <td class="text-xs-center">{{ props.item.unitNo }}</td>
              <td class="text-xs-center">{{ props.item.erfNo }}</td>
              <td class="text-xs-center">{{ props.item.otherNo }}</td>
              <td class="text-xs-center">{{ props.item.complexStreetName }}</td>
              <td
                class="text-xs-center"
                v-if="props.item.locationNetworkSubComplexId !== null"
              >
                {{ props.item.locationNetworkSubComplex.subcomplexName }}
              </td>
              <td v-else></td>
              <td class="text-xs-center">
                {{ props.item.locationNetwork.name }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api.js";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    loading: Loading,
  },
  data() {
    return {
      startPicker:false,
      slaTypes: ['Access Control', 'Camera', 'Fibre', 'Other'],
      customers:[],
       snackbar: false,
      errorSnackbar: false,
      text: "",
      y: "top",
      initial:[],
      slaChangedObj: {},
      editingSla:false,
      key:0,
      locationFilter: null,
      filteredCategoryItems: [],
      filteredUsers: [],
      addTemplate: false,
      ticketTemplates: [],
      locations: [],
      locationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo",
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo",
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo",
        },
        {
          text: "Street Name",
          align: "center",
          value: "complexStreetName",
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subcomplexName",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
      ],
      locationSearch: "",
      filteredLocations: [],
      addLocationModal: false,
      locationType: "",
      locationNetworks: [],
      locationNodes: [],
      switchingCentres: [],
      initialAssignedId: null,
      locationTypeList: [
        "End Location",
        "Location Network",
        "Location Node",
        "Switching Centre",
      ],
      logArray: [],
      load: false,
      loading: false,
      dateKey: 0,
      hoursUsed: 0,
      dateTimeSelect: false,
      selectedMonth: null,
      selectedDate: null,
      availableMonths: [],
      ticketOptions: {},
      addTicketModal: false,
      ticketHoursLog: [],
      startTime: "",
      stoppedTime: "",
      stoppedDate: "",
      addHoursBox: false,
      ticketHours: {},
      ticketAssignedLog: [],
      ticketCommentLog: [],
      filteredUsers: [],
      addCommentBox: false,
      comment: "",
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketCategoryItems: [],
      ticketCategories: [],
      today: this.formatDate(new Date()),
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      serviceDetail: [],
      tickets: [],
      headers: [
        {
          text: "Status",
          align: "center",
          value: "currentStatus",
        },
        {
          text: "Ticket ID",
          align: "center",
          value: "id",
        },
        {
          text: "Category",
          align: "center",
          value: "ticketCategoryItem.ticketCategory.name",
        },
        {
          text: "Subcategory",
          align: "center",
          value: "ticketCategoryItem.name",
        },
        {
          text: "Description",
          align: "center",
          value: "description",
        },
        {
          text: "Priority",
          align: "center",
          value: "importance",
        },
        {
          text: "Created By",
          align: "center",
          value: "createdBy.name",
        },
        {
          text: "Assigned To",
          align: "center",
          value: "assignedTo.name",
        },
        {
          text: "Resolved By",
          align: "center",
          value: "resolvedBy.name",
        },
      ],
    };
  },
  watch: {
    async selectedMonth(value) {
      if (value) {
        
        let month = this.monthNames.indexOf(value.split(" ")[0]);
        let year = value.split(" ")[1];
        this.selectedDate = new Date(year, month, 1);
        let startMonth = new Date(
          this.selectedDate.getFullYear(),
          this.selectedDate.getMonth(),
          1
        );
        let endMonth = new Date(
          this.selectedDate.getFullYear(),
          this.selectedDate.getMonth() + 1,
          0
        );
        let timeArray = await this.tickets
          .filter(
            (x) =>
              x.isComplete &&
              new Date(x.createdAt) <= endMonth &&
              new Date(x.createdAt) >= startMonth &&
              x.duration
          )
          .map((x) => x.duration);
        this.hoursUsed = timeArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        this.dateKey += 1;
      }
    },
    locationType(value) {
      this.ticketOptions.locationId = null;
      this.ticketOptions.locationNetworkId = null;
      this.ticketOptions.locationNodeId = null;
      this.ticketOptions.switchingCentreId = null;
      this.ticketOptions.location = {};
    },
    "ticketOptions.ticketTemplateId": {
      immediate: true,
      async handler(value) {
        if (value === null && this.ticketOptions.ticketCategoryId != null) {
          Api()
            .get(
              "/ticketCategoryItem/byCategory/" +
                this.ticketOptions.ticketCategoryId
            )
            .then((response) => {
              for (let k = 0; k < response.length; k++) {
                this.filteredCategoryItems = response.data[k];
              }
            });
        }
      },
    },
    "ticketOptions.userRoleId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredUsers = response.data.map((x) => x.contact);
            });
        }
      },
    },
    filterUserRole: {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredAssignedUsers = response.data.map((x) => x.contact);
            });
        } else {
          this.filteredAssignedUsers = this.filteredUsers;
        }
      },
    },
    filterTicketCategory: {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketCategoryItems.filter(
            function (el) {
              return el.ticketCategoryId === value;
            }
          );
        } else {
          this.filteredCategoryItems = this.ticketCategoryItems;
        }
      },
    },
    "ticketOptions.ticketCategoryId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketCategoryItems.filter(
            function (el) {
              return el.ticketCategoryId === value;
            }
          );
        } else {
          this.filteredCategoryItems = this.ticketCategoryItems;
        }
      },
    },
    locationFilter(value) {
      if (value !== null && typeof value !== "undefined") {
        this.filteredLocations = this.locations.filter(function (el) {
          return el.locationNetworkId === value;
        });
      } else {
        this.filteredLocations = this.locations;
      }
    },
    users(value) {
      if (value.length > 0) {
        this.filteredUsers = this.users;
      }
    },
    locations(value) {
      if (value.length > 0) {
        this.filteredLocations = this.locations;
      }
    },
    ticketCategoryItems(value) {
      if (value.length > 0) {
        this.filteredCategoryItems = this.ticketCategoryItems;
      }
    },
  },
  created() {
    this.initialize();
  },
  methods: {
      editSlaInfo() {
      this.editingSla = !this.editingSla;
      console.log(this.initial, this.serviceDetail)
      this.slaChangedObj = {};
      if (this.serviceDetail.customerOrganisationId !== this.initial.customerOrganisationId) {
        this.slaChangedObj.customerOrganisationId = this.serviceDetail.customerOrganisationId;
      }
      if (this.serviceDetail.locationNetworkId !== this.initial.locationNetworkId) {
        this.slaChangedObj.locationNetworkId = this.serviceDetail.locationNetworkId;
      }
      if (this.serviceDetail.type !== this.initial.type) {
        this.slaChangedObj.type = this.serviceDetail.type;
      }
      if (this.serviceDetail.name !== this.initial.name) {
        this.slaChangedObj.name = this.serviceDetail.name;
      }
      if (this.serviceDetail.startDate !== this.initial.startDate) {
        this.slaChangedObj.startDate = this.serviceDetail.startDate;
      }
      if (this.serviceDetail.endDate !== this.initial.endDate) {
        this.slaChangedObj.endDate = this.serviceDetail.endDate;
      }
      if (this.serviceDetail.hours !== this.initial.hours) {
        this.slaChangedObj.hours = this.serviceDetail.hours;
      }
      if (this.serviceDetail.hourlyRate !== this.initial.hourlyRate) {
        this.slaChangedObj.hourlyRate = this.serviceDetail.hourlyRate;
      }
       if (this.serviceDetail.afterHourRate !== this.initial.afterHourRate) {
        this.slaChangedObj.afterHourRate = this.serviceDetail.afterHourRate;
      }
      if (this.serviceDetail.sundayAndPublicHolidayRate !== this.initial.sundayAndPublicHolidayRate) {
        this.slaChangedObj.sundayAndPublicHolidayRate = this.serviceDetail.sundayAndPublicHolidayRate;
      }
      Api()
        .put("/sla/batch/" + this.$route.params.serviceLevelAgreementId, {
          batch: this.slaChangedObj,
        })
        .then(response=> {
          this.getSLADetail()
          this.snackbar = true;
          this.text = "Info Successfully Saved!";
        });
    },
    fetchHoursUsed(){
      let month = this.monthNames.indexOf(this.selectedMonth.split(" ")[0]);
      let year = this.selectedMonth.split(" ")[1];

      Api().post("/ticketJobHours/sla/hoursUsed",{
        ticketId: this.tickets,
        year: year,
        month: month
      }).then(response=>{        
          this.hoursUsed = response.data.counter
          this.dateKey++
      })
    },
    fetchLocations() {
      Api()
        .get("/locations")
        .then((response) => {
          this.locations = response.data;
        });
    },
    initialize() {
      var today = new Date();
      var currentMonth = new Date(today.getFullYear(), today.getMonth());
      this.selectedMonth = this.formatMonth(currentMonth);
      this.selectedDate = today;
      
      this.getSLADetail();
      this.getSLATickets();
      this.getInitialDetail()
      this.fetchTicketCategories();
      this.fetchticketCategoryItems();
      this.fetchOrgContacts();
      this.fetchUserRoles();
      this.fetchLocationNetworks();
      this.getCustomers()
      this.fetchSwitchingCentres();
      this.fetchLocationNodes();
      this.fetchLocations();
      this.fetchTicketTemplates();
      this.fetchHoursUsed()
      this.locationType = "End Location";
    },
     getCustomers(){
        Api().get('/organisation/subOrganisations/customers')
        .then(response=>{
            this.customers = response.data
        })
    },
    clearTemplate() {
      this.ticketOptions.dueDate = ''
      this.ticketOptions.dueTime = ''
      this.ticketOptions.assignedToId = null;
      this.ticketOptions.ticketCategoryItemId = null;
      this.ticketOptions.ticketCategoryId = null;
      this.key++
    },
    populateTemplate() {
      this.clearTemplate();
      for (let i = 0; i < this.ticketTemplates.length; i++) {
        if (
          this.ticketTemplates[i].id === this.ticketOptions.ticketTemplateId
        ) {
          this.ticketOptions.dueDate = this.ticketTemplates[i].dueDate;
          this.ticketOptions.dueTime = this.ticketTemplates[i].dueTime;
          this.ticketOptions.assignedToId = this.ticketTemplates[i].contactId;
          if (this.ticketTemplates[i].ticketCategoryItem !== null) {
            this.ticketOptions.ticketCategoryItemId = this.ticketTemplates[
              i
            ].ticketCategoryItemId;
            this.ticketOptions.ticketCategoryId = this.ticketTemplates[
              i
            ].ticketCategoryItem.ticketCategoryId;
          }
        }
      }
    },
    fetchTicketTemplates() {
      Api()
        .get("/ticketTemplate")
        .then((response) => {
          this.ticketTemplates = response.data;
        });
    },
    fetchSwitchingCentres() {
      Api()
        .get("/switchingCentres")
        .then((response) => {
          this.switchingCentres = response.data;
        });
    },
    fetchLocationNodes() {
      Api()
        .get("/locationNodes")
        .then((response) => {
          this.locationNodes = response.data;
        });
    },
    fetchLocationNetworks() {
      Api()
        .get("/locationNetworks")
        .then((response) => {
          this.locationNetworks = response.data;
        });
    },
    fetchUserRoles() {
      Api()
        .get("/userRole")
        .then((response) => {
          this.userRoles = response.data;
        });
    },
    fetchTicketComments(id) {
      Api()
        .get("/ticketComment/byTicket/" + id)
        .then((response) => {
          this.ticketCommentLog = response.data;
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then((response) => {
          this.ticketAssignedLog = response.data;
        });
    },
    fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then((response) => {
          this.ticketCategories = response.data;
        });
    },
    fetchticketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then((response) => {
          this.ticketCategoryItems = response.data;
          this.ticketKey += 1;
        });
    },
    fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async (response) => {
          this.filteredUsers = response.data
            .filter(function (el) {
              return el.userType !== "endClient";
            })
            .map((x) => x.contact);
          // let contactArray = await this.filteredUsers.map(x => x.contact);
          // this.filteredUsers = contactArray;
        });
    },
    getSLADetail() {
      this.load = true;
      Api()
        .get("/sla/" + this.$route.params.serviceLevelAgreementId)
        .then((response) => {
          this.serviceDetail = response.data;
          this.availableMonths = this.dateRange(
            this.serviceDetail.startDate,
            this.serviceDetail.endDate
          );
          
          this.load = false;
        });
    },
     getInitialDetail() {
      Api()
        .get("/sla/" + this.$route.params.serviceLevelAgreementId)
        .then((response) => {
          this.initial = response.data;
        });
    },
    getSLATickets() {
      this.logArray = [];
      this.loading = true;
      Api()
        .get("/ticket/sla/" + this.$route.params.serviceLevelAgreementId)
        .then(async (response) => {
          this.tickets = response.data;
          this.fetchHoursUsed()
          await this.tickets.map((x) => {
            if (x.timeStarted && x.timeFinished) {
              x.duration = this.timeConversion(
                new Date(x.timeFinished).getTime() -
                  new Date(x.timeStarted).getTime()
              );
            } else {
              x.duration = null;
            }
          });
          let endMonth = new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            0
          );
          let startMonth = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          );
          let timeArray = await this.tickets
            .filter(
              (x) =>
                x.isComplete &&
                new Date(x.createdAt) <= endMonth &&
                new Date(x.createdAt) >= startMonth &&
                x.duration
            )
            .map((x) => x.duration);
          // this.hoursUsed = timeArray.reduce(function (a, b) {
          //   return a + b;
          // }, 0);
          this.loading = false;
        });
    },

    dateRange(startDate, endDate) {
      var start = startDate.split("-");
      var end = endDate.split("-");
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          var j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          // var month = j+1;
          var month = j;
          // var displayMonth = month < 10 ? '0'+month : month;
          dates.push(new Date(i, month));
        }
      }
      return dates;
    },
    timeConversion(millisec) {
      var seconds = (millisec / 1000).toFixed(1);

      var minutes = (millisec / (1000 * 60)).toFixed(1);

      var hours = (millisec / (1000 * 60 * 60)).toFixed(1);

      var days = (millisec / (1000 * 60 * 60 * 24)).toFixed(1);

      // if (seconds < 60) {
      //     return seconds + " Sec";
      // } else if (minutes < 60) {
      //     return minutes + " Min";
      // } else if (hours < 24) {
      //     return hours + " Hrs";
      // } else {
      //     return days + " Days"
      // }
      return parseFloat(hours);
    },
    editTicket(id) {
      this.$router.push({ path: "/ticketSummary/" + id });
    },

    addTicket() {
      this.ticketOptions.currentStatus = "Pending";
      this.ticketOptions.importance = "Average";
      this.ticketHoursLog = [];
      this.ticketCommentLog = [];
      this.addTicketModal = true;
    },
    async createNewTicket() {
      this.ticketOptions.serviceLevelAgreementId = this.$route.params.serviceLevelAgreementId;
      this.ticketOptions.locationNetworkId = this.serviceDetail.locationNetworkId;

      await Api()
        .post("/ticket", this.ticketOptions)
        .then((response) => {
          this.getSLATickets();
          if (this.ticketCommentLog.length > 0) {
            for (let i = 0; i < this.ticketCommentLog.length; i++) {
              this.ticketCommentLog[i].ticketId = response.data.id;
            }
            Api()
              .post("/ticketComment", {
                batch: this.ticketCommentLog,
              })
              .then((response) => {});
          }
          if (this.ticketHoursLog.length > 0) {
            for (let i = 0; i < this.ticketHoursLog.length; i++) {
              this.ticketHoursLog[i].ticketId = response.data.id;
              Api().post("/ticketJobHours", {
                contactId: this.ticketHoursLog[i].contactId,
                startDate: this.ticketHoursLog[i].startDate,
                stoppedDate: this.ticketHoursLog[i].stoppedDate,
                ticketId: this.ticketHoursLog[i].ticketId,
              });
            }
          }
          if (this.ticketOptions.assignedToId) {
            Api().post("/ticketAssignLog", {
              assignedToId: this.ticketOptions.assignedToId,
              assignedById: this.$store.state.user.id,
              ticketId: response.data.id,
            });
          }
        });
      this.addTicketModal = false;
      this.ticketOptions = {};
      this.ticketCommentLog = [];
      this.ticketHoursLog = [];
    },
    addHours(hours) {
      Api()
        .get("/contact/basic/" + hours.contactId)
        .then((response) => {
          if (hours.startTime == null) {
            this.startTime = "00:00";
          } else {
            this.startTime = hours.startTime;
          }
          if (hours.stoppedTime == null) {
            this.stoppedTime = "00:00";
          } else {
            this.stoppedTime = hours.stoppedTime;
          }
          if (typeof hours.stoppedDate === "undefined") {
            this.ticketHoursLog.push({
              contactId: hours.contactId,
              contactName: response.data.name,
              contactSurname: response.data.surname,
              startDate: hours.startDate + " " + this.startTime,
              createdAt: new Date(),
            });
            this.logArray.push({
              contactId: hours.contactId,
              contactName: response.data.name,
              contactSurname: response.data.surname,
              startDate: hours.startDate + " " + this.startTime,
              createdAt: hours.startDate + " " + this.startTime,
              commentLogType: false,
            });
          } else {
            this.ticketHoursLog.push({
              contactId: hours.contactId,
              contactName: response.data.name,
              contactSurname: response.data.surname,
              startDate: hours.startDate + " " + this.startTime,
              stoppedDate: hours.stoppedDate + " " + this.stoppedTime,
              createdAt: new Date(),
            });
            this.logArray.push({
              contactId: hours.contactId,
              contactName: response.data.name,
              contactSurname: response.data.surname,
              startDate: hours.startDate + " " + this.startTime,
              stoppedDate: hours.stoppedDate + " " + this.stoppedTime,
              createdAt: hours.startDate + " " + this.startTime,
              commentLogType: false,
            });
          }

          this.logArray.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          this.ticketHours = {};
          this.addHoursBox = false;
        });
    },
    addComment(comment) {
      this.ticketCommentLog.push({
        commentedBy: this.$store.state.user,
        commentedById: this.$store.state.user.id,
        comment: comment,
        type: "comment",
        createdAt: new Date(),
      });

      this.logArray.push({
        commentedBy: this.$store.state.user,
        commentedByName: this.$store.state.user.name,
        commentedBySurname: this.$store.state.user.surname,
        commentedById: this.$store.state.user.id,
        comment: comment,
        type: "comment",
        createdAt: new Date(),
        commentLogType: true,
      });

      this.logArray.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      this.comment = "";
      this.addCommentBox = false;
    },

    formatMonth(date) {
      if (date !== null) {
        return dateformat(date, "mmmm yyyy");
      } else {
        null;
      }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },

    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
  },
};
</script>
<style scoped>
.v-chip.complete {
  background: rgb(80, 189, 80);
}
.v-chip.incomplete {
  background: red;
}
.v-chip.pending {
  background: orange;
}
.v-chip.inprogress {
  background: lightblue;
}
.v-chip.normal {
  background: grey;
}
.v-chip.average {
  background: rgb(70, 128, 236);
}
.v-chip.notcritical {
  background: rgb(231, 137, 14);
}
.v-chip.urgent {
  background: red;
}
</style>